import { KeyboardEvent } from 'react'

/**
 * クリック可能だが button/a ではない要素（カードやセル）を
 * キーボード操作可能にするための onKeyDown ハンドラ。
 * Enter / Space でクリック相当の操作を発火させる（role="button" と併用する）。
 */
export const handleActivateKey =
  (onActivate: () => void) => (event: KeyboardEvent) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault()
      onActivate()
    }
  }
